import * as actionTypes from '../actions/Actions';

export const initialState = {
  data: {
    redirect: false,
  },
};

// ==============================|| ONBOARDING REDUCER ||============================== //

const redirectReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REDIRECT_FROM_MODAL:
      return {
        ...state,
        data: {
          ...state.data,
          redirect: true,
        },
      };
    case actionTypes.UN_REDIRECT_FROM_MODAL:
      return {
        ...state,
        data: {
          ...state.data,
          redirect: false,
        },
      };
    default:
      return state;
  }
};

export default redirectReducer;
